import { createSlice } from "@reduxjs/toolkit";
import { updateReleaseDocumentStatusAPI } from "../../services/releaseDocAPIs";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const createOrUpdateReleaseDocSlice = createSlice({
  name: "createOrUpdateReleaseDoc",
  initialState: data,
  reducers: {
    createOrUpdateReleaseDocInfo(state) {
      state.isLoading = true;
    },
    createOrUpdateReleaseDocSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    createOrUpdateReleaseDocFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    createOrUpdateReleaseDocReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const createOrUpdateReleaseDocHandler =
  (data, options = {}) =>
  async (dispatch) => {
  try {
    dispatch(createOrUpdateReleaseDocAction.createOrUpdateReleaseDocInfo());
    const response = await updateReleaseDocumentStatusAPI(data, options);
    dispatch(createOrUpdateReleaseDocAction.createOrUpdateReleaseDocSuccess(response));
  } catch (e) {
    const failurePayload =
      e && typeof e === "object" && "message" in e
        ? e
        : { message: e || "Something went wrong." };
    dispatch(
      createOrUpdateReleaseDocAction.createOrUpdateReleaseDocFailure(failurePayload)
    );
  }
};
export default createOrUpdateReleaseDocSlice.reducer;
export const createOrUpdateReleaseDocAction = createOrUpdateReleaseDocSlice.actions;
